// extracted by mini-css-extract-plugin
module.exports = {"content":"notfound_content__faKH_","notfound":"notfound_notfound__8XHRs","code":"notfound_code__n5eIs","text":"notfound_text__xn9Q2","boto":"notfound_boto__BAVeO"};